export const DEFAULT_WORKSPACE_NAME = "Private Workspace";
export const PRETTY_URL_NOT_FOUND_PAGE_TEXT = "404 Page";
export const PRETTY_URL_NOT_FOUND_PAGE = "%_-404-_%";
export const PRETTY_URL_ROOT_PAGE_TEXT = "Root Page";
export const PRETTY_URL_ROOT_PAGE = "";
